export default __webpack_public_path__ + "static/media/ic-exclamation-outlined.5bd82608.svg";